import { CompleteTaskRequestActionEnum, ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import { taskApi } from 'api';

export const moveForwardServiceAgreementProcessApi = async (
  taskId: string,
  serviceAgreementId: string,
  formData?: string,
  action?: string,
  distributionAssignee?: string,
  comment?: string,
  delegateSelection?: boolean,
): Promise<ServiceAgreementV2> => {
  return await taskApi.completeFlowableTask({
    serviceAgreementUid: serviceAgreementId,
    completeTaskRequest: {
      taskId,
      formData,
      action: action as CompleteTaskRequestActionEnum | undefined,
      distributionAssignee,
      comment,
      delegateSelection,
    },
  });
};
